// @ vendors
const { APIGet } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
const { BROKER_CUSTOM_WALLET_PORTFOLIO_ACCOUNT_TYPE } = require('../constants/index');

const getPortfolioListSuccess = data => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_GET_PORTFOLIOS_LIST_SUCCESS,
    payload: data,
});

const getPortfolioListError = data => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_GET_PORTFOLIOS_LIST_ERROR,
    payload: data,
});

const getPortfolioListRequest = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_GET_PORTFOLIOS_LIST_REQUEST,
});

const setExpanded = (idPortfolioAccount) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_EXPANDED,
    payload: {
        idPortfolioAccount
    }
});

const getPortfolioList = () => dispatch => {
    const requestData = {
        query: {
            tipoPortfolioAccountTypeId: BROKER_CUSTOM_WALLET_PORTFOLIO_ACCOUNT_TYPE,
        },
    };

    dispatch(getPortfolioListRequest());
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('brokerCustomWalletGetPortfolios'),
        requestData
    )
    .then(response => {
        dispatch(getPortfolioListSuccess(response));
    })
    .catch(response => {
        dispatch(getPortfolioListError(response.error));
    });
};

module.exports = {
    getPortfolioList,
    setExpanded
};
